import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
@Pipe({
  name: 'date'
})
export class DatePipe implements PipeTransform {
  timeZone: any;

  constructor(
    private sharedDataService: SharedDataService
  ) {
    if (!this.timeZone) {
      this.sharedDataService
        .getUser()
        .subscribe(user => {
          if (user && user.timeZone) {
            this.timeZone = user.timeZone;
          }
        });
    }
  }
  transform(value: any, format: any, timeZone?: any): any {
    if (value) {
      if (timeZone) {
        this.timeZone = timeZone;
      }
      if (format) {
        value = moment(value).tz(this.timeZone).format(format);
      } else {
        const m = moment(value);
        value = moment(value).tz(this.timeZone).format('MM/DD/YYYY HHmm');
      }
    }
    return value;
  }
}
